import React from "react";
import { useNavigate} from 'react-router-dom'
import  aboutPic from '../assets/about.webp';
import {motion} from 'framer-motion'
import '../Component/css/About.css'
import skate from '../assets/skate.png'



function About() { 
    const navigate = useNavigate()
    return (
    <div className="about">
        <section className="portofolio-section sec-padding">
            <div className="container">
                <div className="row">
                        <div className="section-title">
                            <h2>About me.</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="about-img">
                            <div className="aimg-box">
                                <img src={aboutPic} alt="about img" className="aboutimg"/>
                            </div>
                            {/* <p>Not in the mood to read? Watch an introductory video 🎥</p> */}
                        </div>




                        {/* About Me */}
                        <div className="about-text">
                            <div className="title timeline1">
                                <div id="engr">
                                    <div className="title2 timeline-item1">
                                        <h3>Profile</h3>
                                        <p id="bold">Adekoya Tunde
                                        {/* 😀 */}
                                        </p>
                                    </div>
                                    <p>
                                    I specialize in creating amazing digital experiences. Currently, I'm focused on producing accessible, human-centred products for eight billion people on earth, including you.
                                    </p><br />
                                </div>

                                <div id="engr">
                                    <div className="title2 timeline-item1">
                                        <h3>Engineering</h3>
                                            <motion.p whileHover={{scale:1.2, originY:1}} transition={{type: 'tween'}} ><a href="https://github.com/TundeAdekoya" target="_blank"  rel="noopener noreferrer">View Github <i class="fa-brands fa-github"></i></a></motion.p>
                                    </div>
                                    <p>
                                     My experience as an engineer allows me to create and implement innovative solutions to technical problems on both backend and frontend of an application without compromising aesthetics, accessibility and functionality. 
                                    </p>
                                </div>

                                <div id="design">
                                    <div className="title2 two timeline-item1">
                                        <h3>Design</h3>
                                        <motion.p whileHover={{scale:1.2, originY:1}} transition={{type: 'tween'}} ><a href="https://www.behance.net/AdekoyaTunde" target="_blank"  rel="noopener noreferrer">View Behance <i class="fa-brands fa-behance-square"></i></a></motion.p>
                                    </div>
                                    <p>
                                    With over six years of experience in design, I have honed my skill in paying special attention to detail, allowing me to create visually appealing designs. In addition, my strong communication skill enables me to effectively present design concepts to stakeholders and project teams.
                                    </p>
                                </div>

                                <div id="product">
                                    <div className="title2 two timeline-item1">
                                        <h3>Product Management</h3>
                                        <motion.p whileHover={{scale:1.2, originY:1}} transition={{type: 'tween'}} ><a href="https://vercel.com/tundeadekoya" target="_blank"  rel="noopener noreferrer">View Products <i class="fa fa-television"></i></a></motion.p>                                        
                                    </div>
                                    <p className="last">
                                    In both remote and office settings, I have vast experience in teamwork and leadership. My expertise in UX research, product design, and product management helps me integrate into project teams and drive the product's growth.
                                    </p>
                                </div>
                            </div>
                            <div className="article">
                                <h3>What I've written</h3>
                                <div className="timeline2">
                                    <div className="article1 ">
                                        <div className="title2a timeline-item2">
                                        <h3>Python in 2022</h3>
                                            <motion.p whileHover={{scale:1.2, originY:1}} transition={{type: 'tween'}}><a href="https://medium.com/@adekoyatunde/learning-python-in-2022-92d0e1fce469" target="_blank" rel="noopenner noreferrer">View Article <i class="fa-solid fa-newspaper"></i></a></motion.p>                                        
                                        </div>
                                    </div>

                                    <div className="article1">
                                        <div className="title2a timeline-item2">
                                            <h3>Python for Beginners in 2022</h3>
                                            <motion.p whileHover={{scale:1.2, originY:1}} transition={{type: 'tween'}} ><a href="https://medium.com/@adekoyatunde/learning-python-from-scratch-in-2022-c2fbc1270960" target="_blank" rel="noopenner noreferrer">View Article  <i class="fa-solid fa-newspaper"></i></a></motion.p> 
                                        </div>
                                    </div>

                                    <div className="article1">
                                        <div className="title2a last timeline-item2">
                                        <h3>Programming and Design</h3>
                                        <motion.p whileHover={{scale:1.2, originY:1}} transition={{type: 'tween'}}  ><a href="https://medium.com/@adekoyatunde/2022-the-tech-come-up-d8aac42cca5d" target="_blank" rel="noopenner noreferrer">View Article  <i class="fa-solid fa-newspaper"></i></a></motion.p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="article">
                                <h3 className="space">What people say</h3>
                                <div className="timeline3">
                                    <div className="article1">
                                        <div className="title2a b500 timeline-item3">
                                        <h3 >Mr. Joseph Jones Agunbiade </h3>
                                        <motion.p whileHover={{scale:1.1, originY:1}} transition={{type: 'tween'}} ><a href="https://www.linkedin.com/in/josephagunbiade/" target="_blank" rel="noopenner noreferrer">View Reference <i class="fa-brands fa-linkedin"></i></a></motion.p>                                        
                                        </div>
                                        <p className="last underline">
                                        You rarely come across diligent individuals like Tunde. I had the pleasure of managing him for six months...<a href="https://www.linkedin.com/in/adekoya-tunde/details/recommendations/?detailScreenTabIndex=0" target="_blank" rel="noopenner noreferrer" className="minitext"> Read More</a>
                                        </p>
                                    </div>

                                    <div className="article1">
                                        <div className="title2a  b500 timeline-item3">
                                            <h3 >Mr. Kolawole Olagoke</h3>
                                            <motion.p whileHover={{scale:1.1, originY:1}} transition={{type: 'tween'}} ><a href="https://www.linkedin.com/in/kolawole-olagoke-435796153/" target="_blank" rel="noopenner noreferrer">View Reference <i class="fa-brands fa-linkedin"></i></a></motion.p> 
                                        </div>
                                        <p className="last underline">
                                            Tunde is knowledgeable, articulate, and a team player whose contribution on projects is very impactful...<a href="https://www.linkedin.com/in/adekoya-tunde/details/recommendations/?detailScreenTabIndex=0" target="_blank" rel="noopenner noreferrer" className="minitext"> Read More</a>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* What i do when not work work */}
                            <div className="article">
                                <h3> When I'm not working </h3>
                                <div className="timeline4">                               
                                    <div className="article1">
                                        <div className="title2a b500 timeline-item4">
                                            <h3>Making Reaction Videos</h3>
                                            <motion.p whileHover={{scale:1.1, originY:1}} transition={{type: 'tween'}} ><a href="https://www.youtube.com/channel/UC4nHV13gukA1X2ziTADRK0g" target="_blank" rel="noopenner noreferrer">View YouTube <i class="fab fa-youtube"></i></a></motion.p>
                                        </div>
                                        <p>
                                            I casually pass time making youtube video to connect with individuals worldwide.
                                        </p>
                                    </div>
                                    <div className="article1">
                                        <div className="title3a b500 timeline-item4">
                                            <h3>Animated stories</h3>
                                        <div className="p">    
                                        <motion.p whileHover={{scale:1.1, originY:1}} transition={{type: 'tween'}} ><a href="https://www.youtube.com/channel/UC2r5nc6UaZiIzO0ghyhQIeA" target="_blank" rel="noopenner noreferrer">View YouTube <i class="fab fa-youtube"></i></a></motion.p>

                                        <motion.p whileHover={{scale:1.1, originY:1}} transition={{type: 'tween'}} ><a href="https://www.tiktok.com/@its_toons" target="_blank" rel="noopenner noreferrer">TikTok <i class="fa-brands fa-tiktok"></i></a></motion.p>

                                        <motion.p whileHover={{scale:1.1, originY:1}} transition={{type: 'tween'}} ><a href="https://www.instagram.com/its_toons/" target="_blank" rel="noopenner noreferrer">Instagram <i class="fab fa-instagram"></i></a></motion.p>
                                        </div>
                                        </div>
                                        <p>
                                        Sometimes when I'm feeling extremely creative, I make animated stories based on events I learned about on social media.
                                        </p>
                                    </div>
                                    <div className="article1">
                                        <div className="title2a b500 timeline-item4">
                                            <h3>Skateboarding</h3>                                                  
                                        </div>
                                        <p className="last">
                                            You can usually catch me on the road with a skateboard. 
                                            {/* <img src={skate} className='icon' alt="stake-img" /> */}
                                        </p>
                                    </div>
                                    <div className="article1">
                                        <div className="title2a b500 timeline-item4">
                                            <h3>Conversing with people </h3>                                                  
                                        </div>
                                        <p className="last">
                                            <a href="https://www.buymeacoffee.com/tunde.dev"> 
                                                <img align="left" src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" height="50" width="210" alt="tunde.dev" />
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <br/>
                            <br/>
{/* End work Detail */}
                            <div onClick={() => navigate('/Portfolio')} className="go_to1">
                                        <p>Take a peek at my works</p> 
                                        <div className="icon">
                                            <i class="fas fa-angle-right"></i>
                                            <i class="fas fa-angle-right"></i>
                                        </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default About
